import { HttpApiEndpoint, HttpApiGroup, HttpApiSchema } from "@effect/platform";
import * as S from "effect/Schema";
import { PrincipalMiddleware } from "./principal.js";
import { Forbidden } from "./shares.js";
import { LanguageSchema } from "./column-schemas.js";
import { RiskInstanceStatusSchema, csvOf } from "./column-schemas.js";
const CsvUuids = S.transform(S.String, S.Array(S.UUID), {
    strict: true,
    decode: (value) => value
        .split(",")
        .map((item) => item.trim())
        .filter(Boolean),
    encode: (items) => items.join(","),
});
export const ExportAssignmentsParams = S.Struct({
    client_id: S.UUID,
    type: S.optional(S.Literal("document", "online_course", "measure")),
    item_id: S.optional(S.UUID),
    assigned_from: S.optional(S.String),
    assigned_to: S.optional(S.String),
    location_ids: S.optional(CsvUuids),
    include_history: S.optional(S.BooleanFromString),
});
export const ExportAssignments = HttpApiEndpoint.get("exportAssignments", "/reports/assignments.csv")
    .setUrlParams(ExportAssignmentsParams)
    .addSuccess(HttpApiSchema.Uint8Array({ contentType: "text/csv; charset=utf-8" }))
    .addError(Forbidden, { status: 403 });
export const ExportRisksParams = S.Struct({
    client_id: S.UUID,
    language: LanguageSchema,
    location_ids: S.optional(CsvUuids),
    statuses: S.optional(csvOf(RiskInstanceStatusSchema)),
});
export const ExportRisks = HttpApiEndpoint.get("exportRisks", "/reports/risks.csv")
    .setUrlParams(ExportRisksParams)
    .addSuccess(HttpApiSchema.Uint8Array({ contentType: "text/csv; charset=utf-8" }))
    .addError(Forbidden, { status: 403 });
export const reportsGroup = HttpApiGroup.make("reports")
    .add(ExportAssignments)
    .add(ExportRisks)
    .middleware(PrincipalMiddleware);
//# sourceMappingURL=reports.js.map